import React, { useMemo } from 'react';
import style from './style.module.scss'; // won't generate a '.d.ts' file until component is included in the app
import { IHandlers, IProps } from './types';
import NewBookingActionsService, { INewBookingData } from 'app/actions/newBooking.actions';
import { useSelector } from 'react-redux';
import { DiaryRootState } from 'appRoot/rootReducer';
import { BookingMethods } from 'shared-types/SharedTypes';
import ActionButton from 'design-v2/common/ActionButton';
import { IconTypes } from 'external-services/icons-service/icons.types';
import { IconPosition } from 'design-v2/common/ActionButton/types';
import DateUtilsService from 'external-services/date-utils-service';

const NS = 'BookingButtons';
/*
    selectedTable will be reset when angular side popup shows in floorplanV2ReactContainer useEffect return,
    so need pass from props here
 */
export default function BookingButtons({table, onNewBookingClicked}: IProps & IHandlers) {
  const enableBookingCreatorOnFloorplan = useSelector((state: DiaryRootState) => state.floorplanSettingsReducer.floorplanSettings.enableBookingCreatorOnFloorplan);
  const selectedFPTime = useSelector((state: DiaryRootState) => state.floorplanFilterReducer.selectedFloorplanTime);
  const timeZoneId = useSelector((state: DiaryRootState) => state.venueReducer.timeZoneId);
  const selectedFloorplanDate = useSelector(
    (state: DiaryRootState) => state.scheduleReducer.selectedDate
  );
  const isDateToday = useMemo(() => {
    return DateUtilsService.isDateToday(selectedFloorplanDate, timeZoneId);
  }, [selectedFloorplanDate, timeZoneId]);

  const handleClick = (bookingMethod: BookingMethods) => {
    const newBookingProps: INewBookingData = {
      bookDate: selectedFPTime,
      bookTable: table,
      bookingMethod,
      bookingToMove: null,
      customer: null,
    };
    if (enableBookingCreatorOnFloorplan) {
      NewBookingActionsService.onNewBookingOpened(newBookingProps);
    } else {
      NewBookingActionsService.onLegacyNewBooking(newBookingProps);
    }
    if (onNewBookingClicked) {
      onNewBookingClicked(newBookingProps);
    }
  }

  return (
    <div className={style.root}>
      <ActionButton
        handleClick={() => handleClick(BookingMethods.phone)}
        variant={'secondary'}
        text={'New Booking'}
        icon={{iconType: IconTypes.add, iconPosition: IconPosition.LEFT}}
        size={'large'}
        maxWidth={800}
        />
      {isDateToday &&
        <ActionButton
          handleClick={() => handleClick(BookingMethods.walkin)}
          variant={'secondary'}
          text={'Walk in'}
          icon={{iconType: IconTypes.walkIn, iconPosition: IconPosition.LEFT}}
          size={'large'}
          maxWidth={800}
        />
      }

    </div>
  )
}

